<template>
  <section>
    <v-container fluid>
      <!-- Header -->
      <EntityHeader :pageData="pageData" :getData="getData" :getSearch="getSearch" />

      <v-row>
        <v-col cols="12" sm="12">
          <DataTableVue :isLoading="pageData.isLoading" :options="pageData.options" :data="pageData.rows"
            :header="pageData.tableHeader" :backValueMethod="setClickRow" :editValueMethod="edit"
            :deleteValueMethod="deleteMethod" :restoreValueMethod="restoreMethod" :pageData="pageData"></DataTableVue>
        </v-col>
      </v-row>

      <v-row v-if="!pageData.isLoading">
        <v-col cols="12" sm="12">
          <Pagination :pagination="pageData.pagination" :limit="pageData.rowsNumber" :backValueMethod="changePage"
            :isLoading="pageData.isLoading"></Pagination>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("Settings");
import DataTableVue from "@/components/DataTable.vue";
import Pagination from "@/components/ui/Pagination.vue";
import EntityHeader from "@/components/ui/EntityHeader.vue";
export default {
  name: "PermissionsEntity",

  data: () => ({
    pageData: {
      screen_code: "01-004",
      url: null,
      controlRoute: "main/permissions-control",
      entityName: null,
      main: null,
      category: null,
      isLoading: true,
      isTrashed: 1,
      rowsNumber: 15,
      tableHeader: [],
      search: "",
      rows: [],
      options: {},
      page: 1,
      pagination: {},
    },
  }),
  components: {
    DataTableVue,
    Pagination,
    EntityHeader
  },
  computed: {
    ...mapState(["favourites"]),
  },
  mounted() {
    this.pageMainData();
    this.getData();
  },
  methods: {
    ...mapActions(["addFavourites"]),

    addToFav() {
      const fav = {
        screen_code: this.pageData.screen_code,
        name: this.pageData.entityName,
        url: this.pageData.url,
      };
      this.addFavourites(fav).finally(() => { });
    },

    pageMainData() {
      this.pageData.main = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).main_title;
      this.pageData.category = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).cat_title;
      this.pageData.entityName = this.$global.FilterPermissions(
        this.pageData.screen_code
      ).sub_title;
      this.pageData.url = this.$global.FilterPermissions(this.pageData.screen_code).url;
      this.pageData.tableHeader = [
        {
          text: "#",
          sortable: true,
          value: "id",
        },
        {
          text: this.$i18n.t("name"),
          sortable: true,
          value: "full_name",
        },
        {
          text: this.$i18n.t("Email"),
          sortable: true,
          value: "email",
        },
        {
          text: this.$i18n.t("Phone"),
          sortable: true,
          value: "mobile",
        },
        {
          text: this.$i18n.t("job"),
          sortable: true,
          value: "title_name_ar",
        },
        //   {
        //     text: this.$i18n.t("created_at"),
        //     sortable: true,
        //     value: "created_at",
        //   },

        { text: this.$i18n.t("actions"), value: "actions", sortable: false },
      ];
      this.pageData.options = {
        print: this.$global.CheckAction(this.pageData.screen_code, 5),
        delete: this.$global.CheckAction(this.pageData.screen_code, 4),
        edit: this.$global.CheckAction(this.pageData.screen_code, 3),
        restore: this.$global.CheckAction(this.pageData.screen_code, 4),
        view: this.$global.CheckAction(this.pageData.screen_code, 1),
        switch: false,
        selectRow: false,
        sortBy: "id",
        tableHeader: false,
        searchInput: false,
        printButton: false,
        handleClickRow: false,
      };
    },
    getSearch(word) {
      this.pageData.search = word ? word : "";
      this.getData();
    },
    getData() {
      if (this.$global.CheckAction(this.pageData.screen_code, 1)) {
        this.pageData.isLoading = true;
        this.$api
          .GET_METHOD(
            `user?active=${this.pageData.isTrashed}&rows=${this.pageData.rowsNumber}&page=${this.pageData.page}&word=${this.pageData.search}`
          )
          .then((response) => {
            this.pageData.isLoading = false;
            if (response.check) {
              this.pageData.entityName =
                this.pageData.isTrashed == 0
                  ? this.$i18n.t("deleted from") + " " + this.$store.state.activeScreen.sub_title
                  : this.$store.state.activeScreen.sub_title;
              this.pageData.rows = response.data.items.data;
              this.pageData.page = response.data.items.current_page;
              this.pageData.pagination = {
                page: response.data.items.current_page,
                totalPages: response.data.items.last_page,
                per_page: response.data.items.per_page,
                totalRows: response.data.items.total,
              };

            }
          });
      } else {
        this.$router.push("/");
      }
    },
    changePage(page, limit) {
      this.pageData.page = page;
      this.pageData.rowsNumber = limit;
      this.getData();
    },
    deleteMethod(id) {
      this.$api.POST_METHOD(`user/${id}`, { _method: "delete" }).then((response) => {
        if (response.check) {
          this.getData();
        }
      });
    },
    restoreMethod(row) {
      this.$api.POST_METHOD(`user_toggle_active/${row.id}`, null).then((response) => {
        if (response.check) {
          this.getData();
        }
      });
    },
    setClickRow() {
      // this.$router.push(`/main/user/${row.id}`)
    },
    edit(row) {
      console.log("edit", row);
      this.$router.push(`/${this.pageData.controlRoute}/` + row.id);
    },
  },
};
</script>
